import React, { Component, Fragment } from 'react';
import { Table as BootstrapTable, Row, Col } from 'reactstrap';

import Pagination from './Pagination';
import TableTopPagination from './TableTopPagination';
import TableTopSearch from './TableTopSearch';
import SvgRender from 'components/helpers/SvgRender';
import sort_up from 'assets/svg/sort_up.svg';
import sort_down from 'assets/svg/sort_down.svg';

export class Table extends Component {
  render() {
    const {
      headers,
      rows,
      columnWidths,
      extra,
      search,
      onSearch,
      pagination,
      onPageChange,
      defaultSort,
      searchPlaceholder
    } = this.props;
    const isPaginated = pagination !== undefined && onPageChange !== undefined;

    return (
      <Fragment>
        <Row className="align-items-end">
          {extra ? <Col className="pb-2">{extra}</Col> : null}
          <Col xs={'auto'} className="ml-auto">
            {search && <TableTopSearch searchPlaceholder={searchPlaceholder} onSearch={onSearch} />}
            {isPaginated && (
              <TableTopPagination
                currentPage={pagination.current_page}
                totalPages={pagination.last_page || 1}
                totalItems={pagination.total}
                onChange={onPageChange}
              />
            )}
          </Col>
        </Row>
        <div className="table-mm-wrapper position-relative">
          <BootstrapTable className="d-block table-mm">
            <thead className="d-block">
              <tr className="d-flex">
                {headers.map((header, index) => {
                  return (
                    <th
                      className={`d-flex align-items-center border-0 col ${
                        columnWidths ? columnWidths[index] : ''
                      } ${header.sort ? 'pointer sorting' : ''} ${
                        header.sort
                          ? typeof defaultSort.sort_order == 'object'
                            ? defaultSort.sort[header.label]
                              ? `sorting--${defaultSort.sort[header.label]}`
                              : ''
                            : defaultSort.sort_order === 'asc'
                            ? 'sorting--asc'
                            : 'sorting--desc'
                          : ''
                      } ${
                        defaultSort && defaultSort.sort_by === header.label ? 'sorting--active' : ''
                      }`}
                      key={index}
                      onClick={() => {
                        if (header.sort) {
                          this.props.onSort(header.label);
                        }
                      }}
                    >
                      <div className="sort-text mr-1">{header.name}</div>
                      {header.sort ? (
                        <div className="sort-container pt-1">
                          <SvgRender className="sort-desc" path={sort_up} style={{ width: 8 }} />
                          <SvgRender className="sort-asc" path={sort_down} style={{ width: 8 }} />
                        </div>
                      ) : null}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="d-block">
              {rows.map((row, index) => {
                return (
                  <tr key={index} className="d-flex">
                    {row.map((cell, index) => {
                      return (
                        <td
                          className={`d-flex border-0 align-items-${
                            this.props.alignStart ? 'start' : 'center'
                          } col ${columnWidths ? columnWidths[index] : ''} `}
                          key={index}
                        >
                          {cell}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </BootstrapTable>
        </div>

        {isPaginated ? (
          <Row>
            <Col className="d-flex justify-content-end pagination-bottom mt-2">
              <Pagination
                currentPage={pagination.current_page}
                totalPages={pagination.last_page || 1}
                onChange={onPageChange}
              />
            </Col>
          </Row>
        ) : null}
      </Fragment>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/table/index.js